const prefix = process.env.REACT_APP_CDN_ASSET_PREFIX || "/assets";

const regularFont = {
  fontFamily: "orkney",
  src: `local('orkney-Regular'), 
  url('${prefix}/fonts/orkney-regular.eot'),
  url('${prefix}/fonts/Orkney-Regular.woff') format('woff'),
  url('${prefix}/fonts/NeueHaas/Orkney-Regular.woff2') format('woff2')`,
};
const lightFont = {
  fontFamily: "orkney",
  src: `local('orkney-Light'), 
  url('${prefix}/fonts/orkney-light.eot'),
  url('${prefix}/fonts/Orkney-Light.woff') format('woff'),
  url('${prefix}/fonts/Orkney-Light.woff2') format('woff2')`,
};
const MediumFont = {
  fontFamily: "orkney",
  src: `local('orkney-Medium'), 
  url('${prefix}/fonts/orkney-medium.eot'),
  url('${prefix}/fonts/Orkney-Medium.woff') format('woff'),
  url('${prefix}/fonts/Orkney-Medium.woff2') format('woff2')`,
};
const BoldFont = {
  fontFamily: "orkney",
  src: `local('orkney-Bold'), 
  url('${prefix}/fonts/orkney-bold.eot'),
  url('${prefix}/fonts/Orkney-Bold.woff') format('woff'),
  url('${prefix}/fonts/Orkney-Bold.woff2') format('woff2')`,
};

export default [lightFont, MediumFont, BoldFont, regularFont];
